import { useState, useEffect } from 'react';

import { BACKEND_DOMAIN } from '../config/variables';
import { GET } from '../utils/axios.util';

import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const useAssignmentsQueue = () => {

    const [ assignments, setAssignments ] = useState({});

    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    useEffect(() => {

        let payload = {
            url : `${BACKEND_DOMAIN}/assignments/queue`
        }

        if(token) {
            payload['headers'] = {
                'x-access-token': token
            }
        }

        GET(payload).then(res => {
            
            const { data } = res.data
            setAssignments(data)
        }).catch(err => {

            // Session Logout Code
            if(err.response && err.response.status === 401) {
                toast.error('Session Expired! Logging out...', { autoClose: 2000 })
                setTimeout(() => {
                    window.location.reload();
                }, 1000)
            }
            setAssignments({})
        })

    }, [])


    return assignments;

}

export default useAssignmentsQueue